import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';
import { Icon, Trash2 } from '../ui/Icon';

interface Props {
  open: boolean;
  title: string;
  body: string;
  /** Deletes only what the user asked to delete; the other one loses the link. */
  onlyLabel: string;
  onOnly: () => void;
  onBoth: () => void;
  onCancel: () => void;
}

/**
 * ADR-0024: deleting a meal linked to a stop (or the reverse) asks whether the
 * other goes too. Three answers, not two: closing the dialog must cancel, not
 * quietly pick one of the deletes.
 */
export default function LinkedDeleteModal({ open, title, body, onlyLabel, onOnly, onBoth, onCancel }: Props) {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onCancel} title="" size="sm">
      <div className="-mt-8 flex flex-col items-center text-center">
        <div className="w-11 h-11 rounded-full bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-3">
          <Icon as={Trash2} size={20} className="text-red-500" />
        </div>
        <h2 className="font-sans font-semibold text-base text-slate-900 dark:text-slate-100 mb-1">{title}</h2>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-5">{body}</p>
        <div className="flex flex-col gap-2 w-full">
          <button
            type="button"
            onClick={onBoth}
            className="bg-red-500 hover:bg-red-600 text-white text-sm font-semibold py-2 rounded-xl transition-colors cursor-pointer"
          >
            {t('linkedDelete.both')}
          </button>
          <button type="button" onClick={onOnly} className="btn-secondary text-sm">
            {onlyLabel}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="text-sm text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 py-1 cursor-pointer"
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
